import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from '../api/axiosInstance';

function LoginPage() {
  const navigate = useNavigate();
  const [account, setAccount] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const res = await axios.post("/api/User/login", {
        account,
        password,
      });
      const { token, user } = res.data;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      if (user.isAdmin) {
        navigate("/admin");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      setError("登入失敗，請檢查帳號密碼");
    }
  };

  useEffect(() => {
    document.title = "登入 - 健康追蹤系統";
  }, []);

  return (
    <div className="container mt-5" style={{ maxWidth: "400px" }}>
      <h2 className="mb-4 text-center">登入</h2>
      
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="mb-3">
        <label htmlFor="account" className="form-label">帳號</label>
        <input
          type="text"
          id="account"
          className="form-control"
          value={account}
          onChange={(e) => setAccount(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="password" className="form-label">密碼</label>
        <input
          type="password"
          id="password"
          className="form-control"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <div className="d-grid">
        <button onClick={handleLogin} className="btn btn-primary">
          登入
        </button>
      </div>
    </div>
  );
}

export default LoginPage;
